import { PageData, PageForms, PageFormsData, PageQuestion, PageSections } from "../types/hexpertTypes"

export enum HexpertFormBlockEnum {
    FORM_SEPARATOR = 'WeFitSeparatorBlock',
    PRESSURE = 'HexpertPressureChoiceElementBlock',
    TEMPERATURE = 'HexpertTemperatureChoiceElementBlock',
    SUBMIT = "WeFitSubmitButtonElementBlock",
    INDUSTRY = "HexpertIndustryChoiceElementBlock",
    SELECT = "HexpertSelectionDependentOn"
}


export const fieldsToCheckInResult = (forms: PageFormsData[]) => {
    const fieldsToCheck = []
    forms?.forEach((form) => {
        form?.Value?.ElementsArea?.forEach((el, i) => {
            if (

                el?.ContentType === HexpertFormBlockEnum.PRESSURE || el?.ContentType === HexpertFormBlockEnum.TEMPERATURE
            ) {
                fieldsToCheck.push(el?.FieldId)
            }
        })
    })
    return fieldsToCheck
}

// @TODO: Do we really want all this... maybe structure data better ? 
export const formSections = (forms: PageFormsData[], pageProps: PageData) => {
    const hexForms = []
    if (forms?.length < 1) {
        return null
    }

    forms.forEach(form => {
        const tempForm: PageForms = {}
        const tempSections: PageSections[] = []
        tempForm.title = form?.Value?.Title
        tempForm.image = form?.Value?.PreviewImage?.Url
        tempForm.type = form?.Key
        tempForm.formGuid = pageProps?.[form?.Key]
        tempForm.resultIcon = form?.Value?.ResultImage?.Url
        tempForm.id = form?.Value?.Id

        let tempSection: PageSections = {}
        let tempQuestions: PageQuestion[] = []

        form?.Value?.ElementsArea?.forEach((el, i) => {
            const formSection: PageSections = {}

            if (el.ContentType === HexpertFormBlockEnum.FORM_SEPARATOR) {
                // is separator block
                if (el?.DetermineFurtherQuestions) {
                    // adds this prop to section before submit
                    // for formCheck and submit 
                    tempSection.determineFurtherQuestions = true
                }
                if (tempSection?.label !== el.Label) {
                    if (tempQuestions?.length > 0) {
                        tempSection.questions = tempQuestions
                    }
                    //  push all temp questions into section before creating a new
                    if (Object.keys(tempSection)?.length !== 0) {
                        tempSections.push(tempSection)
                        tempQuestions = []
                        tempSection = {
                            questions: []
                        }
                    }
                }

                // prepare new section
                formSection.title = el?.Title
                formSection.label = el?.Label
                formSection.description = el?.SeparatorDescription
                // submit or show result

                formSection.isSubmit = el?.DetermineFurtherQuestions || el.ContentType as string === HexpertFormBlockEnum.SUBMIT

                formSection.isLastStep = form?.Value?.ElementsArea?.length - 1 === i
                tempSection = formSection

            } else if (el?.Conditions && el?.Conditions?.length > 0) {
                // question has condition 
                const conditionQuestion = tempQuestions.find(q => q.ChoiceName === el?.Conditions[0]?.Field)
                if (conditionQuestion) {
                    if (conditionQuestion && conditionQuestion?.conditionQuestions) {
                        conditionQuestion.conditionQuestions = [...conditionQuestion.conditionQuestions, el]
                    } else {
                        conditionQuestion.conditionQuestions = [el]
                    }
                }
            } else {
                tempQuestions.push(el)
            }
            // last question
            if (i === form?.Value?.ElementsArea?.length - 1) {
                tempSection.isSubmit = true
                if (tempQuestions?.length > 0) {
                    tempSection.questions = tempQuestions
                }
                tempSections.push(tempSection)
            }
        })
        tempForm.sections = tempSections
        hexForms.push(tempForm)
    })
    return hexForms
}